import Icon from '../components/Icon';

const GoogleNoBackground = Icon(
  'google-no-background',
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.52 12.271C23.52 11.42 23.4436 10.6019 23.3018 9.81641H12V14.4582H18.4582C18.18 15.9582 17.3345 17.2291 16.0636 18.08V21.091H19.9418C22.2109 19.0019 23.52 15.9255 23.52 12.271Z"
      fill="#4285F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.001 24.0013C15.241 24.0013 17.9573 22.9267 19.9428 21.094L16.0646 18.0831C14.9901 18.8031 13.6155 19.2285 12.001 19.2285C8.87552 19.2285 6.23007 17.1176 5.28643 14.2812H1.27734V17.3903C3.25189 21.3122 7.31007 24.0013 12.001 24.0013Z"
      fill="#34A853"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.28545 14.2785C5.04545 13.5585 4.90909 12.7894 4.90909 11.9985C4.90909 11.2076 5.04545 10.4385 5.28545 9.71847V6.60938H1.27636C0.463636 8.22937 0 10.0621 0 11.9985C0 13.9348 0.463636 15.7676 1.27636 17.3876L5.28545 14.2785Z"
      fill="#FBBC05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.001 4.77273C13.7628 4.77273 15.3446 5.37818 16.5883 6.56727L20.0301 3.12545C17.9519 1.18909 15.2355 0 12.001 0C7.31007 0 3.25189 2.68909 1.27734 6.61091L5.28644 9.72C6.23007 6.88364 8.87553 4.77273 12.001 4.77273Z"
      fill="#EA4335"
    />
  </>
);

export default GoogleNoBackground;
